import React, { Fragment, useState, useEffect } from "react";

import { func, bool, object, arrayOf, string, any } from "prop-types";

import { connect } from "react-redux";
import * as style from "./styles.module.scss";

import { clearErrors, payslipsRequestData } from "../../redux/actions";
import { PayslipStatus } from "../../helpers/payslips";
import { PulseLoader } from "../../common";
import PayslipTryAgain from "../../components/PayslipTryAgain";

const Payslips = ({
  children = () => {},
  isLoading,
  payslips = undefined,
  hasP45 = false,
  // eslint-disable-next-line
  hasP60_2022 = false,
  // eslint-disable-next-line
  hasP60_2023 = false,
  // eslint-disable-next-line
  hasP60_2024 = false,
  // eslint-disable-next-line
  hasP60_2025 = false,
  errors,
  clearErrorsWithSource,
  requestPayslips,
}) => {
  const handleTryAgain = () => {
    clearErrorsWithSource("payslips");
    requestPayslips();
  };
  const payslipErrors =
    errors && errors.filter((error) => error.source === "payslips");
  const hasPayslips = Array.isArray(payslips) && payslips.length > 0;
  const isPayslipsEmpty =
    (!hasPayslips &&
      !isLoading &&
      payslipErrors &&
      payslipErrors.length === 0) ||
    (!hasPayslips && !isLoading && !payslipErrors);

  const [payslipStatus, setPayslipStatus] = useState(PayslipStatus.Loading);

  useEffect(() => {
    if (isLoading) setPayslipStatus(PayslipStatus.Loading);
    if (payslipErrors && payslipErrors.length > 0)
      setPayslipStatus(PayslipStatus.Failed);
    if (hasPayslips || isPayslipsEmpty) setPayslipStatus(PayslipStatus.Success);
  }, [payslips, errors, isLoading]);

  switch (payslipStatus) {
    case PayslipStatus.Loading:
      return (
        <div
          className={`w-100  d-flex flex-column justify-content-center align-items-center`}
        >
          <PulseLoader />
          <h2 className="mt-2">Collecting your payslips</h2>
        </div>
      );
    case PayslipStatus.Success:
      return (
        <Fragment>
          {children({
            isLoading,
            payslips,
            hasP45,
            hasP60_2022,
            hasP60_2023,
            hasP60_2024,
            hasP60_2025,
            requestPayslips,
            errors,
            clearErrorsWithSource,
            handleTryAgain,
            payslipErrors,
            hasPayslips,
          })}
        </Fragment>
      );

    case PayslipStatus.Failed:
      return <PayslipTryAgain handleTryAgain={handleTryAgain} />;

    default:
      return <Fragment>def</Fragment>;
  }
};

Payslips.propTypes = {
  children: func,
  isLoading: bool.isRequired,
  hasP45: bool,
  hasP60_2022: bool,
  hasP60_2023: bool,
  hasP60_2024: bool,
  hasP60_2025: bool,
  payslips: arrayOf(object),
  errors: any,
  clearErrorsWithSource: func,
  requestPayslips: func,
};

const mapStateToProps = ({
  core: {
    // eslint-disable-next-line
    payslips: {
      isLoading,
      payslips,
      hasP45,
      // eslint-disable-next-line
      hasP60_2022,
      // eslint-disable-next-line
      hasP60_2023,
      // eslint-disable-next-line
      hasP60_2024,
      // eslint-disable-next-line
      hasP60_2025,
    },
    errors,
  },
}) => ({
  isLoading,
  payslips,
  hasP45,
  hasP60_2022,
  hasP60_2023,
  hasP60_2024,
  hasP60_2025,
  errors,
});

const mapDispatchToProps = {
  clearErrorsWithSource: clearErrors,
  requestPayslips: payslipsRequestData,
};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

export default withRedux(Payslips);
